
import { Component, Mixins } from 'vue-property-decorator';
import { AthleteRoutingMixin, AuthMixin, BAPartnerMixin, VuetifyMixin } from '@/mixins';

@Component
export default class BestEducation extends Mixins(VuetifyMixin, BAPartnerMixin, AuthMixin, AthleteRoutingMixin) {
    partnerName = "Best Education";
}

